export default {
    getHeaderFields: state => state.headerFields,
    getDataTableOptions: state => state.dataTableOptions,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen
}
